export default function Diplom(props) {
    return (
        <div className="diplom">
            <article><h3>{props.date}</h3></article>
            <article className="descDip"><p>{props.nomDip}</p><p>{props.desDip}</p></article>
            <article><i className={props.icon}></i></article>
        </div>
    );
}